export default "__VITE_ASSET__DuSxhEir__"